// extracted by mini-css-extract-plugin
export default {"silentCheckbox":"UserSettings_silentCheckbox__j8kcU"};